import script from "./questionnaire.vue?vue&type=script&lang=ts&setup=true"
export * from "./questionnaire.vue?vue&type=script&lang=ts&setup=true"

import "./questionnaire.vue?vue&type=style&index=0&id=f0160a36&lang=css"

const __exports__ = script;

export default __exports__